import { Injectable } from '@angular/core';

@Injectable()
export class RoleService {
  private roles: any = {
    1: {
      role: 'Administrator',
      defaultRoute: '/dashboard'
    },
    2: {
      role: 'Accounts',
      defaultRoute: '/invoice'
    },
    3: {
      role: 'Technician',
      defaultRoute: '/calendar'
    },
    4: {
      role: 'Installers',
      defaultRoute: '/jobsheet'
    },
    5: {
      role: 'Maintenance',
      defaultRoute: '/jobsheet'
    }
  };

  constructor() { }

  getDefaultRoute(role: number): string{
    //return "/user";
    return this.roles[role].defaultRoute;
  }
}
